import { Injectable } from "@angular/core";
import { CRMContactConnector } from "./crm-contact.connector";
import { AppServerOrganisationConnector } from "../../app-server-connectors";
import { AuthenticationService, CachingService, IAMService, UIService } from "src/app/services/services.module";
import { FilterQuery, ContactDocument, OrganisationMemberDocument, UserDocument, APIResponse } from "server-model";
import { AppServerCRMContactConnector } from "../../app-server-connectors/app-server-crm-contact.connector";

@Injectable()
export class CRMContactDataService {
    private crmContactConnector: CRMContactConnector;

    constructor(
        private cachingService: CachingService,
        private iamService: IAMService,
        private authenticationService: AuthenticationService,
        private uiService: UIService,
    ) {
        this.crmContactConnector = new AppServerCRMContactConnector(this.iamService, this.authenticationService, this.uiService)
    }

    async getContact(organisationId: string, contactId: string, uniqueFieldName: string = 'id'): Promise<APIResponse> {
        const response = await this.crmContactConnector.getContact(organisationId, contactId, uniqueFieldName);
        return response;
    }
    async createContact(contactDocument: ContactDocument): Promise<APIResponse> {
        const response = await this.crmContactConnector.createContact(contactDocument);
        return response;
    }
    async updateContact(organisationId: string, userId: string, contactId: string, contactDocument: Partial<ContactDocument>, uniqueFieldName: string = 'id'): Promise<APIResponse> {
        const response = await this.crmContactConnector.updateContact(organisationId, userId, contactId, contactDocument, uniqueFieldName);
        return response;
    }
    async deleteContact(organisationId: string, contactId: string): Promise<APIResponse> {
        const response = await this.crmContactConnector.deleteContact(organisationId, contactId);
        return response;
    }
    async listContacts(organisationId: string, userId: string, filterQuery: FilterQuery, isArchived?: boolean): Promise<APIResponse> {
        const response = await this.crmContactConnector.listContacts(organisationId, userId, filterQuery, isArchived);
        return response;
    }
}
